import { useState, createContext, useContext } from 'react';


const LOCAL_STORAGE_KEY = 'user';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const initUserState = localStorage.getItem(LOCAL_STORAGE_KEY)
        ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY))
        : {}; //TODO: Should be null?

    const [currentUser, setCurrentUser] = useState(initUserState);

    const updateUser = (user) => {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(user));
        setCurrentUser(user);
    };

    const clearUserData = () => {
        setCurrentUser({});
        document.cookie = 'user=;Path=/;Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

        localStorage.removeItem('user');
        localStorage.removeItem('users');
        localStorage.removeItem('user_management');
        localStorage.removeItem('config');
        localStorage.removeItem('userSelectValues');
        localStorage.removeItem('projects');
        localStorage.removeItem('project');

        // Quality
        localStorage.removeItem('quality_contents_last_updated');
        localStorage.removeItem('quality_contents_qms_documents');
        localStorage.removeItem('quality_contents_qa_documents');
        localStorage.removeItem('quality_contents_qa_records');

        // Project
        localStorage.removeItem('project_contents_project_id');
        localStorage.removeItem('project_contents_last_updated');
        localStorage.removeItem('project_contents_customer_documents');
        localStorage.removeItem('project_contents_included_documents');
        localStorage.removeItem('project_contents_documents');
        localStorage.removeItem('project_contents_records');
        localStorage.removeItem('project_contents_delivery_lists');
        localStorage.removeItem('project_contents_reports');
        localStorage.removeItem('project_action_item_sources');
        localStorage.removeItem('project_action_items');
    };

    const value = {
        currentUser,
        updateUser,
        clearUserData,
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuthContext must be used within an AuthProvider');
    }
    return context;
};